import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const plaformsApiRoutes = {
    list: apiDataManagerBaseURL + "platforms",
    load: apiDataManagerBaseURL + "platforms/",
};

export class PlatformAPI {
    static list() {
        return API.authenticatedRequest({
            url: plaformsApiRoutes.list,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static load(id) {
        return API.authenticatedRequest({
            url: plaformsApiRoutes.load + id,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}



// WEBPACK FOOTER //
// ./src/api/datamanager/PlatformAPI.js